export const COMPOUND_ESTIMATION_ERRORS = {
  multiple_peaks:
    'Injection contains a few peaks for compound. Only injections with exactly 1 peak are used for calibration calculations.',
};
